<template>
  <div class="text mb-sm">
    <slot name="close"></slot>
    <label class="ml" v-if="data.title">{{ data.title }} <span v-if="data.require" class="text-danger">*</span></label>
    <div class="text-muted ml">{{ data.placeholder }}</div>
    <div class="attach-icon ml mt-sm">
      <i class="el-icon-plus font-lg text-muted" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'AttachPreview',
  props: {
    data: Object
  }
}
</script>
<style lang="scss" scoped>
.text {
  font-size: 14px;
  padding: 12px 15px;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  background-color: #fafafa;
  .attach-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border: 1px solid #cccccc;
    border-radius: 4px;
  }
}
</style>
